const state = {
  userId: -1,
  date: '',

  // 项目树变量
  projectTreeVal: {
    projectId: '',
    orgName: ''
  }
}

const getters = {
  getUserId (state) {
    return state.userId
  },

  getProjectId (state) {
    return state.projectTreeVal.projectId
  },

  getOrgName (state) {
    return state.projectTreeVal.orgName
  },
  getDate (state) {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    //  let endTime = `${year}-${month}-${day}`;
    // this.nowTime = endTime; // 当前的时间点
    let befDate = new Date(date.getTime() - 7 * 24 * 3600 * 1000)
    let byear = befDate.getFullYear()
    let bmonth = befDate.getMonth() + 1
    let bday = befDate.getDate()
    // let startTime = `${byear}-${bmonth}-${bday}`;
    // this.weekBeforeTime = startTime; // 向前推迟一周的时间点

    // 默认日期赋值
    return [new Date(byear + ', ' + bmonth + ', ' + bday), new Date(year + ', ' + month + ', ' + day)]
  }
}

// const actions = {
// };

const mutations = {
  setUserId (state, val) {
    state.userId = val
    console.log('state.userId=' + state.userId)
  },

  setProjectId (state, val) {
    state.projectTreeVal.projectId = val
    console.log('setProjectId=' + val)
  },

  setOrgName (state, val) {
    state.projectTreeVal.orgName = val
    console.log('setOrgName=' + val)
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common.js